import { FC } from "react";
import styles from "./Hero.module.scss";
import { useTranslation } from "next-i18next";
import useUtmParams from "~/hooks/useUtmParams";
import { Container } from "~/components/Container";
import Image from "next/image";
import Button from "~/components/Button";
import Trans from "~/types/translationKeys";
import Link from "next/link";

const Hero: FC = () => {
  const { t } = useTranslation();
  const utmParams = useUtmParams();

  return (
    <section className={styles.hero}>
      <Container className="!ơnpx-0 md:!px-4">
        <div className={styles.background}>
          <div className={styles.background_image}>
            <Image
              src="/hero/3_5.webp"
              alt="Hero"
              width={718}
              height={718}
              priority
              fetchPriority="high"
              quality={30}
            />
          </div>

          <div className={styles.content}>
            <Image
              fill
              src="/svgs/dot_2.svg"
              className={styles.dot_2}
              alt="Dot 2"
              fetchPriority="high"
              priority
            />
            <div className={styles.header}>
              <div className="flex flex-col gap-3 items-center">
                <h1 className={styles.title}>
                  Next-gen AI for Customer Support
                </h1>

                <p className={styles.description}>
                  Tap into the power of{" "}
                  <span className="font-bold">
                    AI Agents, automated Workflows,
                  </span>{" "}
                  and smooth{" "}
                  <span className="font-bold">Human Collaboration</span>.<br />
                  Transform your operations and increase efficiency by up to{" "}
                  <span className="font-bold">500%!</span>
                </p>
              </div>

              <Link
                type="outline"
                href={{
                  pathname: `${process.env.NEXT_PUBLIC_DASHBOARD_URL}/sign-up`,
                  query: { ...utmParams },
                }}
                target="_blank"
              >
                <Button>{t(Trans.start_for_free)}</Button>
              </Link>
            </div>

            <video
              src="/videos/main.webm"
              autoPlay
              muted
              loop
              playsInline
              preload="auto"
              className={styles.video}
            >
              {t(Trans.your_browser_does_not_support_the_video_tag)}
            </video>

            <div className={styles.footer}>
              <a
                href="https://appsumo.com/products/cx-genie/?query=CX%20Genie%20-%20Plus%20Exclusive"
                target="_blank"
              >
                <Image
                  src="/svgs/app_sumo.svg"
                  alt="App Sumo"
                  width={258}
                  height={24}
                />
              </a>

              <a
                href="https://www.trustpilot.com/review/cxgenie.ai"
                target="_blank"
              >
                <Image
                  src="/svgs/rate_trustpilot.svg"
                  alt="Trustpilot"
                  width={250}
                  height={96}
                />
              </a>

              <a
                href="https://www.producthunt.com/posts/cx-genie-2?embed=true&utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-cx&#0045;genie&#0045;2"
                target="_blank"
              >
                <img
                  src="https://api.producthunt.com/widgets/embed-image/v1/top-post-badge.svg?post_id=486201&theme=light&period=daily"
                  alt="CX&#0032;Genie - Transform&#0032;customer&#0032;support&#0032;with&#0032;no&#0045;code&#0032;AI&#0045;powered&#0032;solutions | Product Hunt"
                  width={250}
                  height={96}
                />
              </a>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Hero;
